import React from 'react'
import { useFormikContext } from 'formik'
import { makeStyles } from 'tss-react/mui'
import { Button } from '@mui/material'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import { WallboxSettingsFormModel } from 'src/Libs/wallboxes/models'
import { initialChargeStrategyConfiguration } from 'src/Libs/wallboxes/transformers/wallbox-common-settings'
import { useApp } from 'src/Hooks'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useDynamicPowerPricesEnabledContext } from 'src/Libs/dynamic-power-prices/context/dynamic-power-prices-enabled-provider'
import { useTheme } from '@mui/system'

const useStyles = makeStyles()(theme => ({
  clearButton: {
    color: theme.palette.buttonGroup.inactiveColor,
    borderColor: theme.palette.buttonGroup.borderColor,
  },
}))

interface Props {
  disabled?: boolean
  displayBidiMode?: boolean
}

/**
 * set the charge strategy configuration values to 0
 */
const ChargeStrategyClearButton: React.FC<Props> = ({ disabled, displayBidiMode }) => {
  const { t } = useCustomTranslation()
  const { setFieldValue } = useFormikContext<WallboxSettingsFormModel>()
  const { isMobile: isDownSm } = useApp()
  const { classes } = useStyles()
  const theme = useTheme()
  const { isDynamicPowerPriceEnabledForWallboxes } = useDynamicPowerPricesEnabledContext()
  const buttonBackground = disabled ? undefined : theme.palette.buttonGroup.inactiveBackground

  const activeChargeStrategyLabel = displayBidiMode
    ? 'systemSettings.wallbox.settings.activeChargeStrategyBidi.label'
    : 'systemSettings.wallbox.settings.activeChargeStrategy.label'

  const description = isDynamicPowerPriceEnabledForWallboxes
    ? 'systemSettings.wallbox.settings.activeChargeStrategy.description.dynamic-electricity-tariff'
    : 'systemSettings.wallbox.settings.activeChargeStrategy.description.static-electricity-tariff'

  const handleClearChargeStrategy = (): void => {
    setFieldValue('chargeStrategyConfiguration', initialChargeStrategyConfiguration)
  }

  return (
    <SettingsBox
      disabled={disabled}
      title={t(activeChargeStrategyLabel)}
      description={t(description)}
      gridSizes={{ mdLeft: 10, mdRight: 2, smLeft: 10, smRight: 2 }}
      suffix={
        <Button
          color="inherit"
          onClick={handleClearChargeStrategy}
          fullWidth={isDownSm}
          className={classes.clearButton}
          sx={{ backgroundColor: buttonBackground }}
          disabled={disabled}
        >
          {t('common.clear')}
        </Button>
      }
    />
  )
}

export default ChargeStrategyClearButton
